import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AccessRole, ButtonColumnType, CustomTableComponent, DataColumnType, ICustomTable, LocalService } from 'lib-base';
import { SeguimientoHistorialComponent } from './seguimiento-historial/seguimiento-historial.component';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom, forkJoin } from 'rxjs';
import { IGetSolicitudActividades } from '../../../../shared/interfaces/database/pqrsd';
import { SolicitudActividadesService } from '../../../../services/database/pqrsd/solicitud-actividades.service';

@Component({
  selector: 'app-solicitud-historial',
  standalone: true,
  imports: [CommonModule, CustomTableComponent, SeguimientoHistorialComponent],
  templateUrl: './solicitud-historial.component.html',
  styleUrl: './solicitud-historial.component.scss'
})
export class SolicitudHistorialComponent implements OnInit {
  @Input() solicitudId !: number;

  customTable !: ICustomTable;
  trans: any = {};
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;
  role = AccessRole;

  constructor(public readonly ls: LocalService, private readonly _router: Router, private readonly _t: TranslateService, private readonly _tas: SolicitudActividadesService) {
  }

  ngOnInit(): void {
    this.translate().then(() => this.configureTable());
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      actividad: this._t.get('common.actividad'),
      orden: this._t.get('common.orden'),
      usuarioAsignado: this._t.get('common.usuarioAsignado'),
      estado: this._t.get('common.estado'),
      abrir: this._t.get('common.abrir'),
      fechaInicioPlanificada: this._t.get('msg.fechaInicioPlanificada'),
      fechaCierrePlanificada: this._t.get('msg.fechaCierrePlanificada'),
      fechaInicioReal: this._t.get('msg.fechaInicioReal'),
      fechaFinalizacionReal: this._t.get('msg.fechaFinalizacionReal'),
      actividades: this._t.get('common.actividades'),
      fir: this._t.get('common.fir'),
      ffr: this._t.get('common.ffr'),
      fip: this._t.get('common.fip'),
      fcp: this._t.get('common.fcp'),
    }));
  }

  configureTable(): any {
    this.customTable = {
      columns: [
        {
          field: 'expand',
          header: '',
          width: '0.5rem',
          buttonType: ButtonColumnType.EXPANDED
        },
        {
          field: 'codificacion',
          header: this.trans.actividad,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'orden',
          header: this.trans.orden,
          dataType: DataColumnType.NUMBER
        },
        {
          field: 'usuarioAsignadoCorreo',
          header: this.trans.usuarioAsignado,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'estadoDescripcion',
          header: this.trans.estado,
          dataType: DataColumnType.ESTADO_TAG
        },
        {
          field: 'fechaRealInicio',
          header: this.trans.fir,
          sort: true,
          dataType: DataColumnType.DATE,
          headerTooltip: {
            message: this.trans.fechaInicioReal,
            disabled: false
          }
        },
        {
          field: 'fechaRealCierre',
          header: this.trans.ffr,
          dataType: DataColumnType.DATE,
          headerTooltip: {
            message: this.trans.fechaFinalizacionReal,
            disabled: false
          }
        },
        {
          field: 'fechaPlanificadaInicio',
          header: this.trans.fip,
          sort: true,
          dataType: DataColumnType.DATE,
          headerTooltip: {
            message: this.trans.fechaInicioPlanificada,
            disabled: false
          }
        },
        {
          field: 'fechaPlanificadaCierre',
          header: this.trans.fcp,
          dataType: DataColumnType.DATE,
          headerTooltip: {
            message: this.trans.fechaCierrePlanificada,
            disabled: false
          }
        },
        {
          field: 'abrir',
          header: '',
          label: this.trans.abrir,
          icon: 'pi pi-folder-open',
          class: 'button-edit p-button-outlined pt-2 pb-2',
          width: '0rem',
          buttonType: ButtonColumnType.CUSTOM,
          onClick: (event: Event, data: IGetSolicitudActividades) => this.refreshCurrentRoute(data),
          disabled: !(this.ls.hasRole(this.role.GESTION_PQRSD) || this.ls.hasRole(this.role.ADMIN_PQRSD)),
          visible: {
            property: 'fechaRealCierre',
            value: null
          }
        }
      ],
      settings: {
        table: {
          rows: 8
        }
      }
    } as ICustomTable;
  }

  getHistorial() {
    this._tas.getSolicitudActividades(this.solicitudId).subscribe({
      next: (data: IGetSolicitudActividades[]) => {
        this.customTableComponent.data = data;
      }
    });
  }

  refreshCurrentRoute(data: IGetSolicitudActividades): void {
    this._router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this._router.navigate(['/configuracion/pqrsd-actividad', this.solicitudId, data.id]);
    });
  }
}
